import { render, staticRenderFns } from "./SwitchHistoryDialog.vue?vue&type=template&id=6d07c7e8&"
import script from "./SwitchHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./SwitchHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports